import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { BrowserRouter } from 'react-router-dom';
import './i18n.js';
import '@fontsource-variable/inter';
import '@fontsource-variable/literata';
import '@fontsource-variable/literata/wght-italic.css';
import './styles.css';
import App from './App.js';
import { applyTheme, getStoredTheme, watchSystemTheme } from './theme.js';

applyTheme(getStoredTheme());
watchSystemTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const persister = createSyncStoragePersister({ storage: window.localStorage, key: 'b4b-cache' });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 24 * 3600 * 1000,
        dehydrateOptions: {
          // persist feed data (+ layout settings) for offline reading, never auth state
          shouldDehydrateQuery: (query) =>
            query.state.status === 'success' &&
            ['clusters', 'cluster', 'feeds', 'topics', 'settings'].includes(String(query.queryKey[0])),
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistQueryClientProvider>
  </React.StrictMode>,
);
